import React, { useState, useRef } from 'react';
import Navigation from './component/Navigation';
import { Route, Switch } from 'react-router-dom';
import Login from './component/Login';
import DashBoard from './component/DashBoard';
import RequestHistory from './component/RequestHistory';
import RequestHistoryDetails from './component/RequestHistoryDetails';
import SalesHistory from './component/SalesHistory';
import Vendor from './component/Vendor';
import Footer from './component/Footer';
import ProtectedRoute from './component/ProtectedRoute';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer } from 'react-toastify';
import UserList from './component/UserList';
import VendorList from './component/VendorList';
import VendorRecharge from './component/VendorRecharge';
import User from './component/User';
import PaymentHistory from './component/PaymentHistory';
import SaleHistoryDetails from './component/SaleHistoryDetails';
import IdleTimer from 'react-idle-timer';
import IdleTimeOutModal from './common/IdleTimeOutModal';
import ChangePassword from './component/ChangePassword';
// import LogRocket from 'logrocket';
import FloatList from './component/FloatList';
import EndDayHistory from './component/EndDayHistory';
import TokenReprint from './component/TokenReprint';
import SalesReport from './component/SalesReport';
import AdminRoute from './component/AdminRoute';
import ReportRoute from './component/ReportRoute';
import { MainContextProvider } from './component/MainContext';

function App(props) {
   const idleRef = useRef();
   const [timeOut, setTimeOut] = useState(1000 * 60 * 19);
   const [showModal, setShowModal] = useState();
   const [elapsedTime, setElapsedTime] = useState();

   // LogRocket.init('i3ibzi/evs');

   const handleLogout = () => {
      localStorage.removeItem('username');
      window.location = '/';
   };

   const handleClose = () => {
      setShowModal(false);
      handleLogout();
   };
   const onActive = (e) => {};

   const onAction = (e) => {
      if (idleRef.current) idleRef.current.reset();
   };

   const onIdle = (e) => {
      const { pathname } = window.location;
      const elapsedTime = Math.ceil(idleRef.current.getElapsedTime() / (1000 * 60));
      if (pathname !== '/' && pathname !== '/login') {
         setElapsedTime(elapsedTime);
         setShowModal(true);
      }
   };

   return (
      <React.Fragment>
         <MainContextProvider>
            <IdleTimer ref={idleRef} element={document} onActive={onActive} onIdle={onIdle} onAction={onAction} debounce={250} timeout={timeOut} />
            <Navigation />
            <ToastContainer />
            <br />
            <main>
               <Switch>
                  <Route exact path={'/'} component={Login} />
                  <Route path={'/login'} component={Login} />
                  <AdminRoute path={'/DashBoard'} component={DashBoard} />
                  <ProtectedRoute path={'/RequestHistory'} component={RequestHistory} />
                  <ProtectedRoute path={'/RequestHistoryDetails/:transactionId'} component={RequestHistoryDetails} />
                  <ProtectedRoute path={'/SalesHistory'} component={SalesHistory} />
                  <ProtectedRoute path={'/SaleHistoryDetails/:transactionId'} component={SaleHistoryDetails} />
                  <ProtectedRoute path={'/PaymentHistory'} component={PaymentHistory} />
                  <ProtectedRoute path={'/ChangePassword/:userId'} component={ChangePassword} />
                  <AdminRoute path={'/Vendor'} component={Vendor} />
                  <ReportRoute path={'/VendorList'} component={VendorList} />
                  <AdminRoute path={'/VendorRecharge/:vendorAccountId'} component={VendorRecharge} />
                  <AdminRoute path={'/User/:userId'} component={User} />
                  <AdminRoute path={'/FloatList'} component={FloatList} />
                  <AdminRoute path={'/TokenReprint'} component={TokenReprint} />
                  <AdminRoute path={'/User'} component={User} />
                  <AdminRoute path={'/UserList'} component={UserList} />
                  <ReportRoute path={'/EndDayHistory'} component={EndDayHistory} />
                  <ReportRoute path={'/SalesReport'} component={SalesReport} />
                  <AdminRoute path={'/User'} component={User} />
                  <AdminRoute path={'/UserList'} component={UserList} />
               </Switch>
               <IdleTimeOutModal showModal={showModal} handleClose={handleClose} handleLogout={handleLogout} elapsedTime={elapsedTime} />
            </main>
            <Footer />
         </MainContextProvider>
      </React.Fragment>
   );
}

export default App;
